import PageLayout from "components/layout/PageLayout";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLazyGetUserBiaDataQuery, useLazyGetUserBloodPressureDataQuery, useLazyGetUserECGListQuery, useLazyGetUserHrDataQuery, useLazyGetUserSp02DataQuery, useLazyGetUserStepsDataQuery, useLazyGetUserTempsDataQuery, useLazyGetUserVO2MaxDataQuery } from "./api/healthDataApi";
import { useEffect, useState } from "react";
import { useGetUsersQuery } from "features/core/users/usersApiSlice";
import { useLazyGetHealthPatientDetailQuery } from "../patients/api/healthPatientsApiSlice";
import { HrHistoryGraph } from "./views/HrHistoryGraph";
import { HealthPatientCard } from "./views/HealthPatientCard";
import { StepsHistoryGraph } from "./views/StepsHistoryGraph";
import { HealthUserEvents } from "../events/components/HealthUserEvents";
import ECGMeasurements from "./components/ECGMeasurements";
import { Sp02HistoryGraph } from "./views/Sp02HistoryGraph";
import HealthMeasurementActions from "./components/HealthMeasurementActions";
import { TempHistoryGraph } from "./views/TempHistoryGraph";
import { BiaGraph } from "./views/BiaGraph";
import { BloodPressureHistoryGraph } from "./views/BloodPressureHistoryGraph";
import { useSelector } from "react-redux";
import { selectCurrentUserGuid } from "features/auth/authSlice";
import { Calendar } from "primereact/calendar";
import { VO2MaxHistoryGraph } from "./views/VO2MaxHistoryGraph";

const HealthHistory = ({
    privateOnly = false
}) => {

    const [t] = useTranslation(["global", "health"]);
    const currentUserGuid = useSelector(selectCurrentUserGuid)
    let location = useLocation();
    let locationUserId = location.state?.userGUID
    let locationDate = location.state?.date
    const [userId, setUserId] = useState(privateOnly ? currentUserGuid : locationUserId || null);
    const [date, setDate] = useState((locationDate ? new Date(locationDate * 1000) : null) || new Date());

    // Funzioni per ottenere inizio e fine della giornata
    const getStartOfDay = () => Math.floor(date.setHours(0, 0, 0, 0));
    const getEndOfDay = () => Math.floor(date.setHours(23, 59, 59, 999));

    // API
    const [fetchHrData, { data: hrData, isFetching: hrIsFetching, isSuccess: hrIsSuccess }] = useLazyGetUserHrDataQuery()
    const [fetchSp02Data, { data: sp02Data, isFetching: sp02IsFetching, isSuccess: sp02IsSuccess }] = useLazyGetUserSp02DataQuery()
    const [fetchBPData, { data: bpData, isFetching: bpIsFetching, isSuccess: bpIsSuccess }] = useLazyGetUserBloodPressureDataQuery()
    const [fetchTempsData, { data: tempsData, isFetching: tempsIsFetching, isSuccess: tempsIsSuccess }] = useLazyGetUserTempsDataQuery()
    const [fetchStespData, { data: stepsData, isFetching: stepsIsFetching, isSuccess: stepsIsSuccess }] = useLazyGetUserStepsDataQuery()
    const [fetchVO2MaxData, { data: vO2MaxData, isFetching: vO2MaxIsFetching, isSuccess: vO2MaxIsSuccess }] = useLazyGetUserVO2MaxDataQuery()
    const [fetchBiaData, { data: biaData, isFetching: biaIsFetching, isSuccess: biaIsSuccess }] = useLazyGetUserBiaDataQuery()
    const [fetchPatient, { data: patient, isFetching: patientIsFetching, isSuccess: patientIsSuccess }] = useLazyGetHealthPatientDetailQuery()
    const [fetchECGList, { data: ecgList, isSuccess: ecgListIsSuccess }] = useLazyGetUserECGListQuery();

    const {
        data: users,
        isSuccess: usersIsSuccess,
        isFetching: usersIsFetching,
        refetch: refetchUsers
    } = useGetUsersQuery()

    const handleRefresh = () => {
        if (!userId || userId == "") {
            refetchUsers()
        } else {
            fetchPatient(userId)
            fetchHrData({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchSp02Data({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchBPData({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchECGList({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchTempsData({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchStespData({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchVO2MaxData({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })

            fetchBiaData({
                userGuid: userId,
                start: getStartOfDay(),
                end: getEndOfDay()
            })
        }
    }

    useEffect(() => {
        if (userId)
            fetchPatient(userId)
    }, [userId])

    useEffect(() => {

        if (!userId)
            return

        fetchHrData({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })

        fetchSp02Data({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })
        fetchBPData({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })


        fetchTempsData({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })

        fetchECGList({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })

        fetchStespData({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })

        fetchVO2MaxData({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })


        fetchBiaData({
            userGuid: userId,
            start: getStartOfDay(),
            end: getEndOfDay()
        })

    }, [userId, date])


    let content = (
        <>
            <div className="row">

                {
                    usersIsSuccess && !privateOnly &&
                    <div className="col-lg-6">
                        <div className="card bg-black bg-opacity-10  text-white p-4">
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    {t("health:entity.patient.props.name")}
                                </div>
                                <div className="col-auto">
                                    <select className="form-select" aria-label="Default select example" value={userId} onChange={
                                        (e) => {
                                            console.log("TargetValue " + e.target.value)
                                            setUserId(e.target.value)
                                        }
                                    }>
                                        <option selected value=""> {t("health:helper.select_patient")}</option>
                                        {
                                            users.map(user => (<option key={user.guid} value={user.guid}>{user.displayName}</option>))
                                        }
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>
                }

                <div className="col-lg-6">
                    <div className="card bg-black bg-opacity-10  text-white p-4">
                        <div className="row align-items-center">
                            <div className="col-auto">
                                Data:</div>
                            <div className="col-4">
                                <Calendar value={date} onChange={(e) => setDate(e.value)} dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className="col">
                {
                    patientIsSuccess &&
                    <>
                        <HealthPatientCard patient={patient} />
                        <HealthMeasurementActions patient={patient} />
                    </>
                }
                {
                    patientIsSuccess && hrIsSuccess && hrData.length > 0 &&
                    <HrHistoryGraph
                        hrData={hrData}
                        hrThresholds={[patient.profile.features.find(f => f.name === "HR-SAFEZONE").settings.min, patient.profile.features.find(f => f.name === "HR-SAFEZONE").settings.max]}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && vO2MaxIsSuccess && vO2MaxData.length > 0 &&
                    <VO2MaxHistoryGraph
                        vo2MaxData={vO2MaxData}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && sp02IsSuccess && sp02Data.length > 0 &&
                    <Sp02HistoryGraph
                        sp02Data={sp02Data}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && bpIsSuccess && bpData.length > 0 &&
                    <BloodPressureHistoryGraph
                        bpData={bpData}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && ecgListIsSuccess && ecgList.length > 0 &&
                    <ECGMeasurements
                        ecgList={ecgList}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && tempsIsSuccess && tempsData.length > 0 &&
                    <TempHistoryGraph
                        tempsData={tempsData}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && stepsIsSuccess && stepsData.length > 0 &&
                    <StepsHistoryGraph
                        stepsData={stepsData}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess && biaIsSuccess && biaData.length > 0 &&
                    <BiaGraph
                        biaData={biaData}
                        patientInfo={patient.info}
                        date={date}
                        onDateChange={setDate}
                    />
                }

                {
                    patientIsSuccess &&
                    <HealthUserEvents userGuid={userId} onEventClick={(eventInfo) => {
                        setDate(new Date(eventInfo.event.extendedProps.eventDto.timestamp * 1000))
                    }} />
                }

            </div>
        </>
    );


    return (
        <PageLayout
            pageTitle={t("health:menu.data_ext")}
            isLoadingContent={patientIsFetching || hrIsFetching || stepsIsFetching || usersIsFetching}
            onPageRefresh={handleRefresh}
            bodyContent={content}
        />

    );

}


export default HealthHistory;


